{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "建立新團隊",
    "HEADER": "團隊",
    "LOADING": "正在取得團隊",
    "DESCRIPTION": "團隊可讓您根據職責將客服分組。一位客服可以屬於多個團隊。協作時，您可以將對話指派給特定團隊。",
    "LEARN_MORE": "瞭解更多關於團隊",
    "COUNT": "{n} 個團隊 | {n} 個團隊",
    "SEARCH_PLACEHOLDER": "搜尋團隊...",
    "NO_RESULTS": "找不到符合搜尋條件的團隊",
    "LIST": {
      "404": "此帳戶中尚未建立任何團隊。",
      "EDIT_TEAM": "編輯團隊",
      "NONE": "無"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "建立新團隊",
        "DESC": "為您的新團隊新增標題和描述。"
      },
      "AGENTS": {
        "BUTTON_TEXT": "將客服加入團隊",
        "TITLE": "將客服加入團隊 - {teamName}",
        "DESC": "將客服新增到新建立的團隊。這會讓您可以用團隊的形式處理對話，也可以取得同一個對話的新事件通知。"
      },
      "WIZARD_CREATE": {
        "TITLE": "建立",
        "BODY": "為客服建立新團隊。"
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "新增客服",
        "BODY": "將客服加入團隊。"
      },
      "WIZARD_FINISH": {
        "TITLE": "完成",
        "BODY": "一切準備就緒！"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "編輯團隊詳細資訊",
        "DESC": "編輯團隊的標題和描述。",
        "BUTTON_TEXT": "更新團隊"
      },
      "AGENTS": {
        "BUTTON_TEXT": "更新團隊客服",
        "TITLE": "將客服加入團隊 - {teamName}",
        "DESC": "為新建立的團隊新增客服。當對話被指派至此團隊時，所有已新增的客服都會收到通知。"
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "團隊詳細資訊",
        "ROUTE": "settings_teams_edit",
        "BODY": "變更名稱、描述及其他詳細資訊。"
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "編輯客服",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "編輯團隊中的客服。"
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "完成",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "一切準備就緒！"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "無法儲存團隊詳細資訊，請再試一次。"
    },
    "AGENTS": {
      "AGENT": "客服",
      "EMAIL": "電子郵件",
      "BUTTON_TEXT": "新增客服",
      "ADD_AGENTS": "正在將客服加入您的團隊...",
      "SELECT": "選擇",
      "SELECT_ALL": "選取所有客服",
      "SELECTED_COUNT": "已選取 {total} 位客服中的 {selected} 位。"
    },
    "ADD": {
      "TITLE": "將客服加入團隊 - {teamName}",
      "DESC": "將客服新增到新建立的團隊。這會讓您可以用團隊的形式處理對話，也可以取得同一個對話的新事件通知。",
      "SELECT": "選擇",
      "SELECT_ALL": "選取所有客服",
      "SELECTED_COUNT": "已選取 {total} 位客服中的 {selected} 位。",
      "BUTTON_TEXT": "新增客服",
      "AGENT_VALIDATION_ERROR": "請至少選擇一位客服。"
    },
    "FINISH": {
      "TITLE": "您的團隊已準備就緒！",
      "MESSAGE": "您現在可以用團隊的形式協作處理對話。祝支援順利！",
      "BUTTON_TEXT": "完成"
    },
    "DELETE": {
      "BUTTON_TEXT": "刪除",
      "API": {
        "SUCCESS_MESSAGE": "團隊刪除成功。",
        "ERROR_MESSAGE": "無法刪除團隊，請再試一次。"
      },
      "CONFIRM": {
        "TITLE": "確定要刪除此團隊嗎？",
        "PLACE_HOLDER": "請輸入 {teamName} 以確認",
        "MESSAGE": "刪除團隊將移除已指派給此團隊的對話的團隊指派。",
        "YES": "刪除",
        "NO": "取消"
      }
    },
    "SETTINGS": "設定",
    "FORM": {
      "UPDATE": "更新團隊",
      "CREATE": "建立團隊",
      "NAME": {
        "LABEL": "團隊名稱",
        "PLACEHOLDER": "例如：業務、客戶支援"
      },
      "DESCRIPTION": {
        "LABEL": "團隊描述",
        "PLACEHOLDER": "關於此團隊的簡短描述。"
      },
      "AUTO_ASSIGN": {
        "LABEL": "允許此團隊自動指派。"
      },
      "SUBMIT_CREATE": "建立團隊"
    }
  }
}
